import { useTranslation } from 'react-i18next';

import { IceCream } from './Illustrations/IceCream';
import { StatusPage } from './StatusPage';

export const BadRequest = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<IceCream title={t('status.mistake_image_title')} />}
			status={400}
			heading={t('status.bad_request_title')}
			subheading={t('status.bad_request_description')}
		/>
	);
};
